/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {NavigationTreePlan} from '../bioplanModels';
/**
 * FrontendComponentsNavigationTreeApi - axios parameter creator
 * @export
 */
export const FrontendComponentsNavigationTreeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get navigation tree by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    frontendComponentsNavigationTreePlanIdGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('frontendComponentsNavigationTreePlanIdGet', 'planId', planId);
      const localVarPath = `/frontendComponents/navigationTree/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FrontendComponentsNavigationTreeApi - functional programming interface
 * @export
 */
export const FrontendComponentsNavigationTreeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FrontendComponentsNavigationTreeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get navigation tree by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async frontendComponentsNavigationTreePlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NavigationTreePlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.frontendComponentsNavigationTreePlanIdGet(
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FrontendComponentsNavigationTreeApi.frontendComponentsNavigationTreePlanIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * FrontendComponentsNavigationTreeApi - factory interface
 * @export
 */
export const FrontendComponentsNavigationTreeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FrontendComponentsNavigationTreeApiFp(configuration);
  return {
    /**
     *
     * @summary Get navigation tree by plan ID
     * @param {FrontendComponentsNavigationTreeApiFrontendComponentsNavigationTreePlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    frontendComponentsNavigationTreePlanIdGet(
      requestParameters: FrontendComponentsNavigationTreeApiFrontendComponentsNavigationTreePlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<NavigationTreePlan> {
      return localVarFp
        .frontendComponentsNavigationTreePlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for frontendComponentsNavigationTreePlanIdGet operation in FrontendComponentsNavigationTreeApi.
 * @export
 * @interface FrontendComponentsNavigationTreeApiFrontendComponentsNavigationTreePlanIdGetRequest
 */
export interface FrontendComponentsNavigationTreeApiFrontendComponentsNavigationTreePlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof FrontendComponentsNavigationTreeApiFrontendComponentsNavigationTreePlanIdGet
   */
  readonly planId: string;
}

/**
 * FrontendComponentsNavigationTreeApi - object-oriented interface
 * @export
 * @class FrontendComponentsNavigationTreeApi
 * @extends {BaseAPI}
 */
export class FrontendComponentsNavigationTreeApi extends BaseAPI {
  /**
   *
   * @summary Get navigation tree by plan ID
   * @param {FrontendComponentsNavigationTreeApiFrontendComponentsNavigationTreePlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FrontendComponentsNavigationTreeApi
   */
  public frontendComponentsNavigationTreePlanIdGet(
    requestParameters: FrontendComponentsNavigationTreeApiFrontendComponentsNavigationTreePlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FrontendComponentsNavigationTreeApiFp(this.configuration)
      .frontendComponentsNavigationTreePlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
